// App.tsx - Main application with routing
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from '@/constants/routes';
import { ProtectedRoute } from '@/components/common/ProtectedRoute/ProtectedRoute';
import { AppShell } from '@/components/layout/AppShell/AppShell';

// Auth pages
import { LoginPage } from '@/pages/auth/LoginPage';
import { RegisterPage } from '@/pages/auth/RegisterPage';
import { ForgotPassword } from '@/components/auth/ForgotPassword';
import { ResetPassword } from '@/components/auth/ResetPassword';
import { EmailVerification } from '@/components/auth/EmailVerification';

// Dashboard
import { DashboardPage } from '@/pages/dashboard/DashboardPage';

// Leads
import { LeadsPage } from '@/pages/leads/LeadsPage';
import { LeadDetailPage } from '@/pages/leads/LeadDetailPage';

// Analytics
import { AnalyticsPage } from '@/pages/analytics/AnalyticsPage';

// Integrations
import { IntegrationsPage } from '@/pages/integrations/IntegrationsPage';

// Notifications
import { NotificationsPage } from '@/pages/notifications/NotificationsPage';

// Settings
import { SettingsPage } from '@/pages/settings/SettingsPage';

// Scrapers
import { ScrapersPage } from '@/pages/scrapers/ScrapersPage';

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes */}
        <Route path={ROUTES.LOGIN} element={<LoginPage />} />
        <Route path={ROUTES.REGISTER} element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<EmailVerification />} />

        {/* Protected routes */}
        <Route
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route path={ROUTES.DASHBOARD} element={<DashboardPage />} />
          <Route path={ROUTES.LEADS} element={<LeadsPage />} />
          <Route path={ROUTES.LEAD_DETAILS(':id')} element={<LeadDetailPage />} />
          <Route path={ROUTES.ANALYTICS} element={<AnalyticsPage />} />
          <Route path={ROUTES.INTEGRATIONS} element={<IntegrationsPage />} />
          <Route path={ROUTES.NOTIFICATIONS} element={<NotificationsPage />} />
          <Route path={ROUTES.SCRAPERS} element={<ScrapersPage />} />
          <Route path={ROUTES.SETTINGS} element={<SettingsPage />} />
        </Route>

        {/* Redirects */}
        <Route path="/" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
        <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} replace />} />
      </Routes>
    </BrowserRouter>
  );
};
